var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{staticClass:"spin-wrap",attrs:{"spinning":_vm.spinning}},[_c('div',{ref:"gamePlayer",staticClass:"game-player"})])
}
var staticRenderFns = []

export { render, staticRenderFns }